<template>
  <a-dropdown v-if="currentLang">
    <span class="right-content__action">
      <icon-font :type="languageCodes[currentLang].icon"  style="font-size:20px"/>
    </span>
    <a-menu slot="overlay" :selectedKeys="[currentLang]" @click="changeLang" >
      <a-menu-item
        v-for="locale in locales"
        :key="locale"
      >
        <span role="img" :aria-label="languageCodes[locale].label">{{languageIcons[locale]}}</span>
        {{ languageCodes[locale].label }}
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import i18nMixin from '@/store/i18n-mixin'
import { USER_INFO } from '@/store/mutation-types'

export default {
  name: 'SelectLang',
  mixins: [i18nMixin],
  data () {
    return {
      userInfo: this.$ls.get(USER_INFO) || undefined,
      locales: ['zh_CN', 'en_US', 'ko_KR'],
      languageIcons: {
        'zh_CN': '🇨🇳',
        'zh_TW': '🇭🇰',
        'en_US': '🇺🇸',
        'pt_BR': '🇧🇷',
        'ko_KR': '🇰🇷'
      },
      languageCodes: {
        'zh_CN': {
          label: '简体中文',
          flag: '🇨🇳',
          icon: 'gb-icon-circle-zh-bold'
        },
        'en_US': {
          label: 'English',
          flag: '🇺🇸',
          icon: 'gb-icon-circle-en-bold'
        },
        'ko_KR': {
          label: '한국어',
          flag: '🇰🇷',
          icon: 'gb-icon-circle-kr-bold'
        }
      }
    }
  },
  watch: {
    userInfo: {
      handler: 'changeLang',
      immediate: true
    }
  },
  methods: {
    changeLang ({ key, chooseLanguage } = {}) {
      this.setLang(key || chooseLanguage || 'zh_CN')
    }
  }
}
</script>

<style lang="less" scoped>
.right-content__action .anticon {
  vertical-align: -5px;
}
</style>
